export function setVhUnit() {
  document.documentElement.style.setProperty('--vh', (window.innerHeight / 100).toFixed(3).toString() + 'px');
}

export function setViewportDimensions() {
  document.documentElement.style.setProperty('--window-width', (window.innerWidth).toString());
  document.documentElement.style.setProperty('--window-height', (window.innerHeight).toString());
}

export function setScrollbarWidth() {
  document.documentElement.style.setProperty('--scrollbar-width', `${(window.innerWidth - document.documentElement.clientWidth)}px`);
}

export function isTouchDevice() {
  document.addEventListener('touchstart', () => document.documentElement.classList.add('is-touch'));
}

export function getOrientation() {
  return window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape';
}
